// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7927":"b17528bd","9342":"b53a7689","9984":"b53a7689"}[chunkId] + ".chunk.css";
};